export default "__VITE_ASSET__BXq16zjJ__"